import { map } from 'rxjs/operators';
import { routerCancelAction, routerErrorAction, routerNavigatedAction, routerRequestAction } from '@ngrx/router-store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';

import { globalSpinnerActions } from '../global-spinner';

@Injectable()
export class RouterEffects {
  private readonly actions$ = inject(Actions);

  public readonly requestGlobalSpinner = createEffect(() =>
    this.actions$.pipe(
      ofType(routerRequestAction),
      map(() => globalSpinnerActions.request()),
    ),
  );

  public readonly disposeGlobalSpinner = createEffect(() =>
    this.actions$.pipe(
      ofType(routerNavigatedAction, routerCancelAction, routerErrorAction),
      map(() => globalSpinnerActions.dispose()),
    ),
  );
}
